"use strict"; 
import { TABLE_CELL_MARKER_UTILITIES } from "../util/classes";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { jsDebug } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";
import { TABLE_SORT_ROWS_AUX_FUNCTIONS } from "../util/classes";
import { TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS } from "../util/classes";
import { DOM_AUX_FUNCTIONS } from "../util/classes";

import { Elcon } from "../util/classes";
import { DLG } from "../util/classes";
import { GSP } from "../util/classes";
import { CMP } from "../util/cmp";
import { SMART_CMP } from "../util/smart_cmp";
import { Whisper } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";
import { CdFnCntPayload } from "../util/classes";
import { COMM_LOGIC_TYPE } from "../util/classes";
import { DIALOG500 } from "../util/dialog500";
import { NotifyPlus, NotifyPlusStyleRecord, NotifyPlusAuxFunctions } from "../util/popupPlus_Notify"; // <--- ייבוא הפונקציה הספציפית
import { FacadePlus } from "../util/popupPlus_Facade";

declare var working_org_code: string; // cshtml המשתנה הזה מוגדר בקובץ



enum SYS_Bus101_FID {
    ROW_NUM,
    RECORD_CODE,
    REC_ORG_CODE,
    REC_MODULE_CODE,
    REC_FIRSTNAME,
    REC_LASTNAME,
    REC_USERNAME,
    REC_RAW_PASSWORD,
    REC_HASHED_PASSWORD,
    REC_ROLE1_CODE,
    REC_ROLE2_CODE,
    REC_ROLE3_CODE,
    IFB_RELOAD_RECORD
}


interface SYS_Bus101_REC {
    NUMKEY_as_str: string;
    REC_ORG_CODE_as_str: string;
    REC_MODULE_CODE_as_str: string;
    REC_FIRSTNAME_as_str: string;
    REC_LASTNAME_as_str: string;
    REC_USERNAME_as_str: string;
    REC_RAW_PASSWORD_as_str: string;
    REC_HASHED_PASSWORD_as_str: string;
    REC_ROLE1_CODE_as_str: string;
    REC_ROLE2_CODE_as_str: string;
    REC_ROLE3_CODE_as_str: string;
    IFB_RELOAD_RECORD_as_str: string;
}


export class SYS_Bus101 {


    public static SYS_Bus101_vector_update_function(vector_capsule: VECTOR_Capsule): void {
        UTL.GENERAL_VECTOR_UPDATE_FUNCTION(vector_capsule);
    }

    //===============================================================================================================================





    public static SYS_Bus101_VAR_CURRENT_ROW = 0;
    public static SYS_Bus101_VAR_CURRENT_COLUMN = 0;



    public static SYS_Bus101_trans_fid_string_to_fid_enum(fid: string): SYS_Bus101_FID {

        if (fid == "ROW_NUM") return SYS_Bus101_FID.ROW_NUM;
        if (fid == "RECORD_CODE") return SYS_Bus101_FID.RECORD_CODE;
        if (fid == "REC_ORG_CODE") return SYS_Bus101_FID.REC_ORG_CODE;
        if (fid == "REC_MODULE_CODE") return SYS_Bus101_FID.REC_MODULE_CODE;
        if (fid == "REC_FIRSTNAME") return SYS_Bus101_FID.REC_FIRSTNAME;
        if (fid == "REC_LASTNAME") return SYS_Bus101_FID.REC_LASTNAME;
        if (fid == "REC_USERNAME") return SYS_Bus101_FID.REC_USERNAME;
        if (fid == "REC_RAW_PASSWORD") return SYS_Bus101_FID.REC_RAW_PASSWORD;
        if (fid == "REC_HASHED_PASSWORD") return SYS_Bus101_FID.REC_HASHED_PASSWORD;
        if (fid == "REC_ROLE1_CODE") return SYS_Bus101_FID.REC_ROLE1_CODE;
        if (fid == "REC_ROLE2_CODE") return SYS_Bus101_FID.REC_ROLE2_CODE;
        if (fid == "REC_ROLE3_CODE") return SYS_Bus101_FID.REC_ROLE3_CODE;
        if (fid == "IFB_RELOAD_RECORD") return SYS_Bus101_FID.IFB_RELOAD_RECORD;

        alert(`SYS_Bus101_trans_fid_string_to_fid_enum(). error: unknown fid. fid=${fid}`);
        throw new Error(`SYS_Bus101_slow_trans_fid_to_column_number(). error: unknown fid. fid=${fid}`);
    }



    //------AAA
    public static SYS_Bus101_get_header_row_element(): HTMLTableRowElement {

        const table_obj: TableObject = SYS_Bus101.SYS_Bus101_create_table_object();
        const th_element: HTMLTableSectionElement = table_obj.table_element.tHead;
        const row_element = th_element.rows[0]
        return row_element;
    }

    public static SYS_Bus101_trans_column_index_to_fid_as_str(column_index: number): string {
        const tr_element: HTMLTableRowElement = SYS_Bus101.SYS_Bus101_get_header_row_element();
        const th_element: HTMLTableCellElement = tr_element.cells[column_index];
        const fid_string: string = th_element.dataset.fid;
        return fid_string;
    }


    public static SYS_Bus101_trans_column_number_to_fid(column_index: number): SYS_Bus101_FID {
        const fid_as_str = SYS_Bus101.SYS_Bus101_trans_column_index_to_fid_as_str(/*SYS_Bus101_VAR_CURRENT_COLUMN*/column_index);
        const fid_as_enum: SYS_Bus101_FID = SYS_Bus101.SYS_Bus101_trans_fid_string_to_fid_enum(fid_as_str);
        return fid_as_enum;
    }

    public static SYS_Bus101_trans_fid_to_string(fid: SYS_Bus101_FID) {
        // this is the way to translate in TYPE SCRIPT an ENUM to STRING
        const str: string = SYS_Bus101_FID[fid];
        return str;
    }

    public static SYS_Bus101_slow_trans_fid_to_column_number(fid: SYS_Bus101_FID): number {

        const fid_str = SYS_Bus101.SYS_Bus101_trans_fid_to_string(fid);
        const tr_element: HTMLTableRowElement = SYS_Bus101.SYS_Bus101_get_header_row_element();
        for (let i = 0; i < tr_element.cells.length; i++) {
            const th_element: HTMLTableCellElement = tr_element.cells[i];
            //alert(`loop: th_element.dataset.fid=${th_element.dataset.fid}`);
            if (th_element.dataset.fid == fid_str) {
                return i;
            }
        }
        alert(`SYS_Bus101_slow_trans_fid_to_column_number(). error: unknown fid. fid=${fid}`);
        throw new Error(`SYS_Bus101_slow_trans_fid_to_column_number(). error: unknown fid. fid=${fid}`);
    }

    public static SYS_Bus101_get_NofColumns(): number {
        const header_row_element: HTMLTableRowElement = SYS_Bus101.SYS_Bus101_get_header_row_element();
        const NofColumns: number = header_row_element.cells.length;
        return NofColumns;
    }

    //------BBB


    public static async SYS_Bus101_COM_GetRecord(record_code: number): Promise<SYS_Bus101_REC> {
        debugger;
        if (record_code == (-1)) {
            alert("load_record().record_code==(-1)");
            return;
        }
        const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
        fetch_options.method = 'GET';
        const url = `/sys/sys_bus101?handler=GetRecord&record_code=${record_code}`;

        const response: Response = await fetch(url, fetch_options);
        const REC = await response.json();
        return REC
    }

    public static async SYS_Bus101_reload_record_and_populate(row_number: number): Promise<void> {
        const record_code = SYS_Bus101.SYS_Bus101_trans_row_number_to_record_code(row_number);
        const REC = await SYS_Bus101.SYS_Bus101_COM_GetRecord(record_code);
        SYS_Bus101.SYS_Bus101_POPULATE_ROW(row_number, REC);
    }


    public static async SYS_Bus101_respond_button_reload_record(record_code: number): Promise<void> {
        const row_number = SYS_Bus101.SYS_Bus101_trans_reocrd_code_to_row_number(record_code);
        //const promise = SYS_Bus101_GetRecord(record_code);
        //const REC = await promise;
        //SYS_Bus101_POPULATE_ROW(row_number, REC);
        SYS_Bus101.SYS_Bus101_reload_record_and_populate(row_number);
    }



    public static async SYS_Bus101_respond_button_edit_record(record_code: number): Promise<void> {
        alert("לא ניתן לבצע הזנה בצורה");
    }



    public static SYS_Bus101_SMOOTH_SCROLL_TO_LAST_LINE(): void {
        alert("SYS_Bus101_SMOOTH_SCROLL_TO_LAST_LINE().maybe this public static to be obsolete")
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const last_row_element = TABLE.get_last_row_element_of_table(table_obj.table_element);
        last_row_element.scrollIntoView({ behavior: "smooth" });
    }




















    public static SYS_Bus101_fill_status_element(text: string, color_str: string, background_color_str: string) {
        const status_element = document.getElementById("id-main-window-status-line");
        status_element.textContent = text;
        status_element.style.color = color_str;
        status_element.style.backgroundColor = background_color_str;
    }












    public static SYS_Bus101_trans_row_number_to_record_code(row_number: number): number {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const row_element = TABLE.trans_table_element_and_row_number_to_row_element(table_obj.table_element, row_number)
        const id_str = row_element.id;
        const record_code = UTL.extract_last_number_from_string_as_number(id_str);
        return record_code;
    }


    public static SYS_Bus101_perform_F3(): void {
        const record_code = SYS_Bus101.SYS_Bus101_trans_row_number_to_record_code(SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW);
        SYS_Bus101.SYS_Bus101_respond_button_edit_record(record_code);
    }



    public static SYS_Bus101_trans_record_code_to_id_of_row(record_code: number): string {
        const id_str = `id-row-code-${record_code}`
        return id_str
    }

    public static SYS_Bus101_slow_trans_reocrd_code_to_row_number(record_code: number): number {
        // בגלל שהיא מבצעת לולאה על כל השורות slow פונקציה זו היא מסוג
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const n_of_rows = TABLE.get_number_of_rows_in_table(table_obj.table_element);
        //const column_number = 1; // temp
        const column_number: number = SYS_Bus101.SYS_Bus101_slow_trans_fid_to_column_number(SYS_Bus101_FID.RECORD_CODE);
        for (let row_number = 0; row_number < n_of_rows; row_number++) {
            const row_element = TABLE.trans_table_element_and_row_number_to_row_element(table_obj.table_element, row_number);
            const lp_record_code = UTL.extract_last_number_from_string_as_number(row_element.id);
            //alert(`record_code=${record_code}`)
            //if (cell_element.textContent == record_code) {
            //    return row_number;
            //}
            if (lp_record_code == record_code) {
                return row_number;
            }
        }
        return (-1);
    }


    public static SYS_Bus101_quick_trans_reocrd_code_to_row_number(record_code: number): number {
        const id_str: string = SYS_Bus101.SYS_Bus101_trans_record_code_to_id_of_row(record_code);
        const row_element_as_HTMLElement: HTMLElement = document.getElementById(id_str);
        if (row_element_as_HTMLElement == null) {
            alert("row_element_as_HTMLElement == null");
            return (-1);
        }
        if ((row_element_as_HTMLElement instanceof HTMLTableRowElement) == false) {
            alert("row_element_as_HTMLElement is not HTMLTableRowElement");
            return (-1);
        }
        const row_element_as_HTMLTableRowElement: HTMLTableRowElement = row_element_as_HTMLElement as HTMLTableRowElement;
        if (row_element_as_HTMLTableRowElement == null) {
            alert("row_element == null (z)");
            return (-1);
        }
        const row_number: number = TABLE.trans_row_element_to_row_number(row_element_as_HTMLTableRowElement);
        return row_number;
    }

    public static SYS_Bus101_trans_reocrd_code_to_row_number(record_code: number): number {
        const quick_row_number = SYS_Bus101.SYS_Bus101_quick_trans_reocrd_code_to_row_number(record_code);
        const slow_row_number = SYS_Bus101.SYS_Bus101_slow_trans_reocrd_code_to_row_number(record_code);
        if (quick_row_number != slow_row_number) {
            alert("internal error: slow_row_number != quick_row_number");
            return (-1);
        }
        return quick_row_number;
    }


    public static SYS_Bus101_GET_CELL_ELEMENT_V1(row_number: number, column_number: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_obj.table_element, row_number, column_number);
        return cell_element;
    }

    public static SYS_Bus101_GET_CELL_ELEMENT_V2(row_number: number, fid: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const column_number: number = SYS_Bus101.SYS_Bus101_slow_trans_fid_to_column_number(fid);
        return SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V1(row_number, column_number);
    }

    public static SYS_Bus101_GET_CELL_ELEMENT_V3(record_code: number, column_number: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const row_number = SYS_Bus101.SYS_Bus101_trans_reocrd_code_to_row_number(record_code);
        return SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V1(row_number, column_number);
    }

    public static SYS_Bus101_GET_CELL_ELEMENT_V4(record_code: number, fid: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const row_number = SYS_Bus101.SYS_Bus101_trans_reocrd_code_to_row_number(record_code);
        const column_number: number = SYS_Bus101.SYS_Bus101_slow_trans_fid_to_column_number(fid);
        return SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V1(row_number, column_number);
    }


    public static SYS_Bus101_GET_CELL_CONTENT_V1(row_number: number, column_number: number, elcon: Elcon): string {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V1(row_number, column_number);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }

    public static SYS_Bus101_GET_CELL_CONTENT_V2(row_number: number, fid: number, elcon: Elcon): string {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V2(row_number,fid);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }

    public static SYS_Bus101_GET_CELL_CONTENT_V3(record_code: number, column_number: number, elcon: Elcon): string {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V3(record_code, column_number);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }

    public static SYS_Bus101_GET_CELL_CONTENT_V4(record_code: number, fid: number, elcon: Elcon): string {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V4(record_code, fid);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }


    public static SYS_Bus101_PUT_CELL_CONTENT_V1(row_number: number, column_number: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V1(row_number, column_number);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }

    public static SYS_Bus101_PUT_CELL_CONTENT_V2(row_number: number, fid: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V2(row_number, fid);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }

    public static SYS_Bus101_PUT_CELL_CONTENT_V3(record_code: number, column_number: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V3(record_code, column_number);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }


    public static SYS_Bus101_PUT_CELL_CONTENT_V4(record_code: number, fid: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V4(record_code, fid);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }



    public static SYS_Bus101_POPULATE_ROW(row_number: number, REC: SYS_Bus101_REC): void { // XX
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.RECORD_CODE, Elcon.textContent, REC.NUMKEY_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_ORG_CODE, Elcon.textContent, REC.REC_ORG_CODE_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_MODULE_CODE, Elcon.textContent, REC.REC_MODULE_CODE_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_FIRSTNAME, Elcon.textContent, REC.REC_FIRSTNAME_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_LASTNAME, Elcon.textContent, REC.REC_LASTNAME_as_str);

        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_USERNAME, Elcon.textContent, REC.REC_USERNAME_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_RAW_PASSWORD, Elcon.textContent, REC.REC_RAW_PASSWORD_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_HASHED_PASSWORD, Elcon.textContent, REC.REC_HASHED_PASSWORD_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_ROLE1_CODE, Elcon.textContent, REC.REC_ROLE1_CODE_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_ROLE2_CODE, Elcon.textContent, REC.REC_ROLE2_CODE_as_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(row_number, SYS_Bus101_FID.REC_ROLE3_CODE, Elcon.textContent, REC.REC_ROLE3_CODE_as_str);
    }

    public static async SYS_Bus101_COM_CreateNewRecord(): Promise<SYS_Bus101_REC> {
        debugger;
        FacadePlus.Append_V2_F6();
        const token = UTL.ASP_GetAntiForgeryToken();
        const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
        fetch_options.method = "POST";
        fetch_options.headers = { 'RequestVerificationToken': token };
        fetch_options.cache = "no-store";
        const org_code_str = working_org_code;
        const url = `/sys/sys_bus101?handler=CreateNewRecord&org_code=${org_code_str}`;
        const response: Response = await fetch(url, fetch_options);
        const REC = await response.json();
        await UTL.sleep_async(500);
        NotifyPlus.Close();
        return REC;
    }



    public static async SYS_Bus101_PERFORM_APPEND_RECORD(): Promise<void> {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const freezed_number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element);
        const freezed_last_row_num = freezed_number_of_rows;
        const REC = await SYS_Bus101.SYS_Bus101_COM_CreateNewRecord();
        //------------------------------------------------------------------------------------------
        const record_code_as_str = REC.NUMKEY_as_str;
        const record_code = parseInt(record_code_as_str, 10);
        const NofColumns = SYS_Bus101.SYS_Bus101_get_NofColumns();
        const row_id_str = SYS_Bus101.SYS_Bus101_trans_record_code_to_id_of_row(record_code);
        //------------------------------------------------------------------------------------------
        TABLE.ADD_EMPTY_ROW_WITH_EMPTY_CELLS_AT_END_OF_TABLE(table_obj.table_element, NofColumns);
        //------------------------------------------------------------------------------------------
        const last_row_number = TABLE.get_last_row_number_of_table(table_obj.table_element);
        const last_row_element = TABLE.get_last_row_element_of_table(table_obj.table_element);
        const last_ROW_NUM_str = String(last_row_number + 1);
        last_row_element.id = row_id_str;
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(last_row_number, 0, Elcon.textContent, last_ROW_NUM_str);
        SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V2(last_row_number, SYS_Bus101_FID.IFB_RELOAD_RECORD, Elcon.innerHTML, REC.IFB_RELOAD_RECORD_as_str);
        SYS_Bus101.SYS_Bus101_POPULATE_ROW(last_row_number, REC);
        SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW = last_row_number;
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = 0; // column of ROW_NUM
        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
    }


    public static SYS_Bus101_REFRESH_SITE(): void {
        //cmux_refresh_site();
    }


    public static async SYS_Bus101_COM_PostField(p_record_code: number, p_field_name_str: string, p_field_value_str: string, location: TABLE_Location): Promise<void> {
        debugger;
        // FetchExt() להזכירך: בנוגע לפונקציות מסוג "שגר ושכח" אין צורך וגם בלתי אפשרי להשתמש ב
        // FetchExt() להזכירך: בנוגע לפונקציות מסוג "שגר ושכח" אין צורך וגם בלתי אפשרי להשתמש ב
        // FetchExt() להזכירך: בנוגע לפונקציות מסוג "שגר ושכח" אין צורך וגם בלתי אפשרי להשתמש ב
        const info: VECTOR_Info = new VECTOR_Info(p_field_name_str, p_field_value_str, location.row, location.column);
        const token = UTL.ASP_GetAntiForgeryToken();
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const row_number = SYS_Bus101.SYS_Bus101_trans_reocrd_code_to_row_number(p_record_code);



        const obj: CdFnCntPayload = new CdFnCntPayload();
        obj.record_code_as_str = p_record_code.toString();
        obj.field_name_str = p_field_name_str;
        obj.field_content_str = p_field_value_str;


        const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
        fetch_options.method = "POST";
        fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
        fetch_options.body = JSON.stringify(obj);
        const url = `/sys/sys_bus101?handler=PostField&record_code=${p_record_code}`;  // record_code שים לב שאין באמת שימוש ב
        VECTOR.Send(url, fetch_options, info, SYS_Bus101.SYS_Bus101_vector_update_function);
    }







    public static async SYS_Bus101_Keys_Insert(): Promise<void> {
        const row_number = SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW;
        const fid = SYS_Bus101.SYS_Bus101_trans_column_number_to_fid(SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN);
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const location: TABLE_Location = new TABLE_Location(SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW, SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN);
        const record_code = SYS_Bus101.SYS_Bus101_trans_row_number_to_record_code(SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW);
        const cell_element = SYS_Bus101.SYS_Bus101_GET_CELL_ELEMENT_V1(SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW, SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN);
        //======================================
        // added vars for GSP.InputDialogAsync()
        //--------------------------------------
        const column_number = SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN;
        let field_name_str = TRANS.quick_trans_enum_object_and_number_to_string(SYS_Bus101_FID, fid);
        //======================================

        if (fid == SYS_Bus101_FID.ROW_NUM) {
            await DLG.HPromptfAsync("לא ניתן לבצע שינוי בעמודת הספרור");
        }
        if (fid == SYS_Bus101_FID.RECORD_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הרשומה ממסך זה");
            await DLG.HPromptfAsync("you should not be able to do this");
        }
        if (fid == SYS_Bus101_FID.REC_ORG_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הארגון ממסך זה");
            await DLG.HPromptfAsync("you should not be able to do this");
        }
        if (fid == SYS_Bus101_FID.REC_MODULE_CODE) {
            const OBJ: oInt64 = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oInt64) as oInt64;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_FIRSTNAME) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_LASTNAME) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_USERNAME) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_RAW_PASSWORD) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_HASHED_PASSWORD) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_ROLE1_CODE) {
            const OBJ: oInt64 = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oInt64) as oInt64;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_ROLE2_CODE) {
            const OBJ: oInt64 = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oInt64) as oInt64;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_ROLE3_CODE) {
            const OBJ: oInt64 = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oInt64) as oInt64;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }





        if (fid == SYS_Bus101_FID.IFB_RELOAD_RECORD) {  
            await DLG.HPromptfAsync("אם ברצונך לבצע טעינת רשומה יש לבצע זאת באמצעות לחיצה על הכפתור באמצעות העכבר");
        }
    }



    public static async SYS_Bus101_Keys_Delete(): Promise<void> {
        const fid = SYS_Bus101.SYS_Bus101_trans_column_number_to_fid(SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN);
        let field_name_str = TRANS.quick_trans_enum_object_and_number_to_string(SYS_Bus101_FID, fid);
        const record_code = SYS_Bus101.SYS_Bus101_trans_row_number_to_record_code(SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW);
        const row_number = SYS_Bus101.SYS_Bus101_trans_reocrd_code_to_row_number(record_code);
        const column_number = SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN;
        //if (fid == (-1)) {
        //    alert("internal error. fid==(-1) unrecoginzed field");
        //}
        const location: TABLE_Location = new TABLE_Location(SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW, SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN);
        if (fid == SYS_Bus101_FID.ROW_NUM) {
            await DLG.HPromptfAsync("לא ניתן לבצע שינוי בעמודת הספרור");
        }
        if (fid == SYS_Bus101_FID.RECORD_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הרשומה ממסך זה");
            await DLG.HPromptfAsync("you should not be able to do this");
        }
        if (fid == SYS_Bus101_FID.REC_ORG_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הארגון ממסך זה");
            await DLG.HPromptfAsync("you should not be able to do this");
        }
        if (fid == SYS_Bus101_FID.REC_MODULE_CODE) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_FIRSTNAME) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_LASTNAME) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_USERNAME) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_RAW_PASSWORD) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_HASHED_PASSWORD) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_ROLE1_CODE) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_ROLE2_CODE) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == SYS_Bus101_FID.REC_ROLE3_CODE) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                SYS_Bus101.SYS_Bus101_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                SYS_Bus101.SYS_Bus101_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }





        if (fid == SYS_Bus101_FID.IFB_RELOAD_RECORD) {
            await DLG.HPromptfAsync("אם ברצונך לבצע טעינת רשומה יש לבצע זאת באמצעות לחיצה על הכפתור באמצעות העכבר");
        }
    }


    //LLLLLL
    public static SYS_Bus101_ADD_MARK_TO_CURRENT_ROW(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        TABLE_CELL_MARKER_UTILITIES.PAINT_ROW(table_obj.table_element, SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW, "yellow", "black");
        TABLE_CELL_MARKER_UTILITIES.PAINT_CELL_GIVEN_ROW_AND_COLUMN(table_obj.table_element, SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW, SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN, "lightgreen", "black");
    }

    public static SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        TABLE_CELL_MARKER_UTILITIES.RESTORE_ROW(table_obj.table_element, SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW);

    }


    public static SYS_Bus101_ADJ_UP(): void {
        if (SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW > 0) {
            SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW -= 1;
            SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
        }
    }




    public static SYS_Bus101_ADJ_DOWN(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element) 
        if (SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW < (number_of_rows -1)) {
            SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW += 1;
            SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
        }
    }

    public static SYS_Bus101_ADJ_LEFT(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();    
        //const number_of_columns = TABLE.trans_table_element_to_number_of_columns(table_obj.table_element);
        const number_of_columns = TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW(table_obj.table_element, SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW);
        if (SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN < (number_of_columns - 1)) {
            SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN += 1;
            SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
        }
    }

    public static SYS_Bus101_ADJ_RIGHT(): void {
        if (SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN > 0) {
            SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN -= 1;
            SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
        }
    }


    public static SYS_Bus101_ADJ_NEXT(): void {
        for (let i=0; i < 20; i++) {
            SYS_Bus101.SYS_Bus101_ADJ_UP();
        }
    }

    public static SYS_Bus101_ADJ_PRIOR(): void {
        for (let i=0; i < 20; i++) {
            SYS_Bus101.SYS_Bus101_ADJ_DOWN();
        }
    }


    public static SYS_Bus101_ADJ_HOME(): void {
        SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = 0;
        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
    }

    public static SYS_Bus101_ADJ_CONTROL_HOME(): void {
        SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW = 0;
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = 0;
        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
    }

    public static SYS_Bus101_ADJ_END(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();    
        const number_of_columns = TABLE.trans_table_element_to_number_of_columns(table_obj.table_element);
        SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
        const last_col = (number_of_columns - 1);
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = last_col;
        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
    }

    public static SYS_Bus101_ADJ_CONTROL_END(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();    
        const number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element) 
        const number_of_columns = TABLE.trans_table_element_to_number_of_columns(table_obj.table_element);
    
        SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW = (number_of_rows - 1);

        if (false) {
            const last_col = (number_of_columns - 1);
            SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = last_col;
        }
        if (true) {
            // מעדיפים את זה ככה
            const first_col = 0;
            SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = first_col;
        }



        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
    }





    public static SYS_Bus101_keydown_event_should_preventDefault(event: KeyboardEvent): boolean {
       if (event.key === 'Escape') return true;
       if (event.key === 'Insert') return true;
       if (event.key === 'Delete') return true;
       if (event.key === 'ArrowUp') return true;
       if (event.key === 'ArrowDown') return true;
       if (event.key === 'ArrowLeft') return true;
       if (event.key === 'ArrowRight') return true;
       if (event.key === 'PageUp') return true;
       if (event.key === 'PageDown') return true;
       if (event.key === 'Home') return true;
       if (event.key === 'End') return true;
       if (event.key === 'F1') return true;
       if (event.key === 'F2') return true;
       if (event.key === 'F3') return true;
       if (event.key === 'F6') return true;
       //------------------------------------
       return false;
    }




    public static async SYS_Bus101_keydown(event: KeyboardEvent): Promise<void> {

        if (UTL.modal_is_opened == true || UTL.block_everything == true) {
            return;
        }
        if (SYS_Bus101.SYS_Bus101_keydown_event_should_preventDefault(event) == true)
        {
            event.preventDefault(); // Prevents the default help dialog
        }




        if (event.key === 'Insert') {
            //event.preventDefault(); // Prevents the default help dialog
            await SYS_Bus101.SYS_Bus101_Keys_Insert();
        }

        if (event.key === 'Delete') {
            //event.preventDefault(); // Prevents the default help dialog
            await SYS_Bus101.SYS_Bus101_Keys_Delete();
        }

        if (event.key === 'F2') {
            //event.preventDefault(); // Prevents the default help dialog
            await SYS_Bus101.SYS_Bus101_Keys_Insert();
        }
        if (event.key === 'F3') {
            //event.preventDefault(); // Prevents the default help dialog
            SYS_Bus101.SYS_Bus101_perform_F3();
        }
        if (event.key === 'F1') {
            //event.preventDefault(); // Prevents the default help dialog
            alert("F1 ready to use")
        }
        if (event.key === 'F6') {
            //event.preventDefault(); // Prevents the default help dialog
            await SYS_Bus101.SYS_Bus101_PERFORM_APPEND_RECORD();
        }

        if (event.key === 'Enter') {
            //centerModal();               
        }
        if (event.key === 'Escape') {
            //event.preventDefault(); // <-- this disables the default behavior
            // פתוח או לא. בשלב זה תמיד סוגרים. בהמשך עדיף לבצא בדיקה Modal בשלב זה אנחנו לא בודקים האם ה
            // פתוח או לא. בשלב זה תמיד סוגרים. בהמשך עדיף לבצא בדיקה Modal בשלב זה אנחנו לא בודקים האם ה
            // פתוח או לא. בשלב זה תמיד סוגרים. בהמשך עדיף לבצא בדיקה Modal בשלב זה אנחנו לא בודקים האם ה
            //hideModal();
        }
        if (event.key === 'ArrowUp') {
            //event.preventDefault(); // <-- this disables the default behavior
            SYS_Bus101.SYS_Bus101_ADJ_UP();
        }
        if (event.key === 'ArrowDown') {
            //event.preventDefault(); // <-- this disables the default behavior
            SYS_Bus101.SYS_Bus101_ADJ_DOWN();
        }
        if (event.key === 'ArrowLeft') {
            //event.preventDefault(); // <-- this disables the default behavior
            SYS_Bus101.SYS_Bus101_ADJ_LEFT();
        }
        if (event.key === 'ArrowRight') {
            //event.preventDefault(); // <-- this disables the default behavior
            SYS_Bus101.SYS_Bus101_ADJ_RIGHT();
        }
        if (event.key === 'PageUp') {
            //event.preventDefault(); // <-- this disables the default behavior
            SYS_Bus101.SYS_Bus101_ADJ_NEXT();
        }
        if (event.key === 'PageDown') {
            //event.preventDefault(); // <-- this disables the default behavior
            SYS_Bus101.SYS_Bus101_ADJ_PRIOR();
        }
        if (event.key === 'Home') {
            //event.preventDefault(); // <-- this disables the default behavior
            if (event.ctrlKey == false) SYS_Bus101.SYS_Bus101_ADJ_HOME();
            if (event.ctrlKey == true) SYS_Bus101.SYS_Bus101_ADJ_CONTROL_HOME();
        }
        if (event.key === 'End') {
            //event.preventDefault(); // <-- this disables the default behavior
            if (event.ctrlKey == false) SYS_Bus101.SYS_Bus101_ADJ_END();
            if (event.ctrlKey == true) SYS_Bus101.SYS_Bus101_ADJ_CONTROL_END();
        }
    }







    public static SYS_Bus101_create_table_object(): TableObject {
        const table_obj: TableObject = new TableObject();
        table_obj.table_element = document.getElementById("id-table") as HTMLTableElement;
        table_obj.taco_element = document.getElementById("id-taco");
        table_obj.has_vertical_scroll = true;
        table_obj.has_horizontal_scroll = true;
        table_obj.exist_head = true;
        table_obj.exist_numerator = false;
        table_obj.direction = "rtl";
        return table_obj;
    
    }


    public static SYS_Bus101_SCROLL_TO_CELL_INA(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        TBLSCROLLER.scroll_to_cell_INA(table_obj, SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW, SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN);
    }



    public static SYS_Bus101_TABLE_mousedown(event: MouseEvent): void {
        if (UTL.block_everything == true) {
            return;
        }
        const target_element = event.target as HTMLElement;
        const row_number = TABLE.trans_mouse_target_to_row_number(target_element);
        const column_number = TABLE.trans_mouse_target_to_column_number(target_element);
        if (row_number != (-1) && column_number != (-1)) {
            if (true) {
                SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
                SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW = row_number;
                SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = column_number;
                SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
            }
        }        
    }






    public static SYS_Bus101_test_dialog500(): void {
        const xx = "Error in send_field_to_server:\n\n\n\n error=TypeError: Failed to fetch record_code_as_str=169 field_name_str=REC_FIRSTNAME field_content_str=1234123qwerqwe";
        DIALOG500.create_dialog(xx);
    }

    public static SYS_Bus101_FORMAT1(): void {
        debugger;
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const fids: string[] = ["ROW_NUM", "RECORD_CODE", "REC_ORG_CODE", "REC_MODULE_CODE", "REC_FIRSTNAME", "REC_LASTNAME", "REC_USERNAME", "REC_RAW_PASSWORD", "REC_HASHED_PASSWORD", "REC_ROLE1_CODE", "REC_ROLE2_CODE", "REC_ROLE3_CODE", "IFB_RELOAD_RECORD"];
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_obj.table_element, fids);
    }

    public static SYS_Bus101_FORMAT2(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const fids: string[] = ["ROW_NUM", "RECORD_CODE", "REC_ORG_CODE", "REC_FIRSTNAME", "REC_LASTNAME", "REC_USERNAME", "REC_RAW_PASSWORD", "REC_HASHED_PASSWORD"];
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_obj.table_element, fids);
    }

    public static SYS_Bus101_FORMAT3(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        const fids: string[] = ["ROW_NUM", "REC_ORG_CODE", "REC_MODULE_CODE", "REC_FIRSTNAME", "REC_LASTNAME", "REC_ROLE1_CODE", "REC_ROLE2_CODE", "REC_ROLE3_CODE"];
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_obj.table_element, fids);
    }



    public static SYS_Bus101_logicChanged(element: HTMLInputElement): void {
        //alert("SYS_Bus101_logicChanged " + element.id);
        debugger;
        if (element.id == "id-head-description") {
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", false);
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-description", true);
        }
        if (element.id == "id-head-dbcolumns") {
            debugger;
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", true);
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-description", false);
        }
        if (element.id == "id-head-both") {
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", true);
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-description", true);
        }
    }

    public static SYS_Bus101_respond_button_APPEND_RECORD(): void {
        SYS_Bus101.SYS_Bus101_PERFORM_APPEND_RECORD();
    }


    public static SYS_Bus101_myload(): void {
        const table_obj = SYS_Bus101.SYS_Bus101_create_table_object();
        table_obj.table_element.addEventListener('mousedown', SYS_Bus101.SYS_Bus101_TABLE_mousedown);
        document.addEventListener('keydown', SYS_Bus101.SYS_Bus101_keydown);
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_ROW = 0;
        SYS_Bus101.SYS_Bus101_VAR_CURRENT_COLUMN = 0;
        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus101.SYS_Bus101_SCROLL_TO_CELL_INA();
        //paint_citem(4)
    }





    public static SYS_Bus101_VAR_SORT_columnIndex: number = (-1);
    public static SYS_Bus101_VAR_SORT_last_sort_column: number = (-1);
    public static SYS_Bus101_VAR_SORT_sort_ascending_flag: boolean = true;


    public static SYS_Bus101_compare_strings_by_column(p_str1: string, p_str2: string): number {
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

        const fid = SYS_Bus101.SYS_Bus101_trans_column_number_to_fid(SYS_Bus101.SYS_Bus101_VAR_SORT_columnIndex);
        //alert(`p_columnIndex=${p_columnIndex} fid=${fid}`);
        if (fid == SYS_Bus101_FID.ROW_NUM) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.RECORD_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_ORG_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_MODULE_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_FIRSTNAME) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_LASTNAME) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_USERNAME) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_RAW_PASSWORD) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_HASHED_PASSWORD) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_ROLE1_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_ROLE2_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.REC_ROLE3_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == SYS_Bus101_FID.IFB_RELOAD_RECORD) {

        }
        return 0;
    }



    public static SYS_Bus101_compare_table_rows_by_column(row_element1: HTMLTableRowElement, row_element2: HTMLTableRowElement): number {

        const text1: string = row_element1.cells[SYS_Bus101.SYS_Bus101_VAR_SORT_columnIndex].innerText;
        const text2: string = row_element2.cells[SYS_Bus101.SYS_Bus101_VAR_SORT_columnIndex].innerText;
        const diff: number = SYS_Bus101.SYS_Bus101_compare_strings_by_column(text1, text2);
        if (SYS_Bus101.SYS_Bus101_VAR_SORT_sort_ascending_flag == true) {
            return diff;
        }
        else {
            return -diff;
        }
    }


    public static SYS_Bus101_init_all_sort_icons(): void {
        const allHeaders: NodeListOf<HTMLTableCellElement> = document.querySelectorAll("th");
        for (let i: number = 0; i < allHeaders.length; i++) {
            const header: HTMLTableCellElement = allHeaders[i];
            const icon: HTMLElement = header.querySelector(".cl-th-sort-element");
            if (icon !== null) {
                icon.innerHTML = "↕";
            }
        }
    }


    public static SYS_Bus101_updateSortIcon(th: HTMLTableCellElement, is_ascending: boolean): void {
        SYS_Bus101.SYS_Bus101_init_all_sort_icons();
        const icon: HTMLElement = th.querySelector(".cl-th-sort-element");
        if (icon !== null) {
            if (is_ascending == true) {
                // icon.innerHTML = "↑";
                icon.innerHTML = "▲";
            }
            else {
                // icon.innerHTML = "↓";
                icon.innerHTML = "▼";
            }
        }
    }



    public static SYS_Bus101_sort_table_given_th_element(th_element: HTMLTableCellElement): void {
        SYS_Bus101.SYS_Bus101_REMOVE_MARK_FROM_CURRENT_ROW();
        const columnIndex: number = th_element.cellIndex;
        SYS_Bus101.SYS_Bus101_VAR_SORT_columnIndex = columnIndex;
        const table_element: HTMLTableElement = document.getElementById("id-table") as HTMLTableElement;
        if (table_element === null) {
            throw new Error("Table element not found");
        }
        th_element.dataset.sortDirection = "desc";
        if (SYS_Bus101.SYS_Bus101_VAR_SORT_last_sort_column === columnIndex) {
            SYS_Bus101.SYS_Bus101_VAR_SORT_sort_ascending_flag = !SYS_Bus101.SYS_Bus101_VAR_SORT_sort_ascending_flag;
        }
        else {
            SYS_Bus101.SYS_Bus101_VAR_SORT_last_sort_column = columnIndex;
            SYS_Bus101.SYS_Bus101_VAR_SORT_sort_ascending_flag = true;
        }
        SYS_Bus101.SYS_Bus101_updateSortIcon(th_element, SYS_Bus101.SYS_Bus101_VAR_SORT_sort_ascending_flag);
        TABLE_SORT_ROWS_AUX_FUNCTIONS.sortTable(table_element, SYS_Bus101.SYS_Bus101_compare_table_rows_by_column);
        SYS_Bus101.SYS_Bus101_ADD_MARK_TO_CURRENT_ROW();
    }
}




export const SYS_Bus101_wrapper = {
    SYS_Bus101_myload: SYS_Bus101.SYS_Bus101_myload,
    SYS_Bus101_Keys_Insert: SYS_Bus101.SYS_Bus101_Keys_Insert,
    SYS_Bus101_respond_button_APPEND_RECORD: SYS_Bus101.SYS_Bus101_respond_button_APPEND_RECORD,
    SYS_Bus101_respond_button_reload_record: SYS_Bus101.SYS_Bus101_respond_button_reload_record,
    SYS_Bus101_test_dialog500: SYS_Bus101.SYS_Bus101_test_dialog500,
    SYS_Bus101_sort_table_given_th_element: SYS_Bus101.SYS_Bus101_sort_table_given_th_element,
    SYS_Bus101_FORMAT1: SYS_Bus101.SYS_Bus101_FORMAT1,
    SYS_Bus101_FORMAT2: SYS_Bus101.SYS_Bus101_FORMAT2,
    SYS_Bus101_FORMAT3: SYS_Bus101.SYS_Bus101_FORMAT3,
    SYS_Bus101_logicChanged: SYS_Bus101.SYS_Bus101_logicChanged
};


if (false) {
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    window.onload = SYS_Bus101.SYS_Bus101_myload;
}


